import BpDropdown from "./Dropdown.vue";
// 全局安装组件
const Dropdown = {
  install: function(Vue) {
    Vue.component("bp-dropdown", BpDropdown);
  }
};

// 导出组件
export default Dropdown;
